<template>
  <g
    v-if="layout === 0 && data.length > 1"
    class="legend"
    ref="legend"
    :transform="`translate(${option.margin.left}, ${option.margin.top})`">
    <g
      v-if="d.view"
      v-for="(d, i) in data"
      :key="i"
      :transform="`translate(${i * labelWidth % innerWidth + 4}, ${((i * labelWidth / innerWidth) | 0) * 15})`"
      @click="classesClick(i)">
      <g v-if="d.type === 'line'">
        <line
          x1="0"
          y1="7"
          x2="14"
          y2="7"
          :stroke="d.status ? d.color : '#DDD'"
          stroke-width="1.5"/>
        <circle
          cx="7"
          cy="7"
          r="4"
          :stroke="d.status ? d.color : '#DDD'"
          fill="#FFF"
          stroke-width="1.5"/>
      </g>
      <g v-if="d.type === 'dotLine'">
        <line
          x1="0"
          y1="7"
          x2="14"
          y2="7"
          :stroke="d.status ? d.color : '#DDD'"
          stroke-width="1.5"
          style="stroke-dasharray:3;stroke-dashoffset:1"/>
      </g>
      <g v-if="d.type === 'bar'">
        <rect
          y="0"
          x="0"
          width="14"
          height="14"
          rx="3"
          :fill="d.status ? d.color : '#DDD'"/>
      </g>
      <g v-if="d.type === 'pie'">
        <circle
          cx="7"
          cy="7"
          r="7"
          :fill="d.status ? d.color : '#DDD'"
          stroke-width="1.5"/>
      </g>
      <text
        class="legendText"
        x="20"
        y="12"
        :fill="d.status ? '#000' : '#DDD'">{{ d.title }}</text>
    </g>
  </g>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      myClass: 'bi-label',
      defaultOptions: {
        panelWidth: 1000,
        labelWidthPercent: 25,
        margin: {
          top: 5, left: 0, right: 5, bottom: 3
        }
      }
    };
  },
  computed: {
    option() {
      return Object.assign({}, this.defaultOptions, this.options);
    },
    labelWidth() {
      return (this.innerWidth * this.option.labelWidthPercent) / 100;
    },
    innerWidth() {
      let { panelWidth, margin } = this.option;
      return panelWidth - margin.left - margin.right;
    }
  },
  props: {
    layout: {
      type: Number,
      default: 0
      // 0 横向顶端
    },
    data: {
      type: Array,
      default: () => []
      // 图例主数据
    },
    options: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    classesClick(i) {
      this.$emit('classesClick', i);
    }
  }
};
</script>
<style type="text/css" scoped>
.legend g {
  cursor: pointer;
  font-size: 14px;
}
</style>
